<template>
  <transition name="el-zoom-in-top">
    <div
      v-show="$store.getters.isShowMenuApp"
      class="c-white-background dialog-menu-app"
    >
      <div class="info-user bg-btn-main">
        <div class=" flex justify-content-between container">
          <p class="m-0 c-body2 c-white fw-cv2 ">Menu</p>
          <div @click="handleCloseProfile">
            <img :src="icons.CloseIcon" alt="" />
          </div>
        </div>
      </div>
      <div
        style="max-width:900px"
        class="full-width container colum  cursor-pointer"
      >
        <div>
          <Menu />
        </div>
        <div style="margin-top: 30px;" class="text-center">
          <call-button />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import CloseIcon from "@/assets/img/iconV2/closeWhite.svg";
import { decodeToken, getBackGround } from "@/utils/wapAuth";
import Menu from "@/views/pages/wapV2/profile/components/menuApp.vue";
import { formatNumber } from "@/plugins/init";
import { getToken } from "@/utils/wapAuth";
import CallButton from "../../../../components/wapV2/button/call.vue";
export default {
  components: { Menu, CallButton },
  bodyClass: "dialog-menu-app",
  props: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  data() {
    return {
      bg: getBackGround(),
      icons: {
        CloseIcon
      },
      images: {
        DefaultAvatar:
          "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
      }
    };
  },

  watch: {},
  methods: {
    getToken,
    decodeToken,
    formatNumber,

    handleShowPolicy() {
      window.open("https://handee.vn/images/file-member-policy.jpg", "_blank");
    },
    showDialogWallet() {
      this.$store.dispatch("setShowWallet", true);
    },
    handleCloseProfile() {
      this.$store.dispatch("setShowMenuApp", false);
      // console.log(this.$route.name);
      if (this.$route.name === "homepage") return;
      this.$router.push("/wap");
    }
  }
};
</script>
<style lang="scss">
.el-popover {
  border-radius: 10px !important;
}
</style>

<style scoped>
.dialog-menu-app {
  background: #f5f5f5;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  z-index: 2000;
}

.divider-view {
  height: 10px !important;
  width: 100%;
  background-color: #e3e3e3;
  margin: 30px 0;
}

.top-spacing {
  padding-top: 100px;
}

.divider-view {
  height: 1px;
  width: 100%;
  margin-bottom: 10px;
  background-color: #ececec;
}

.px-20 {
  padding-left: 20px;
  padding-right: 20px;
}

@media screen and (min-width: 0px) and (max-width: 769px) {
  .top-spacing {
    padding-top: 60px !important;
  }
}
</style>

<style lang="scss">
$divider-color: #d9d9d9;

.divider-view-top {
  height: 15px;
  width: 100%;
}

.column {
  flex-direction: column;
}
.desktop {
  display: block;
}
.mobile {
  display: none;
}
.uppercase {
  text-transform: uppercase;
}
.full-width {
  width: 100%;
}

@media screen and (min-width: 0px) and (max-width: 480px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
@media screen and (min-width: 769px) and (max-width: 980px) {
  .top-spacing {
    padding-top: 60px !important;
  }
}
</style>
